import type { MoneyView } from './Transaction';

/** Período seleccionado nos filtros globais. */
export type PeriodPreset = 'all' | 'current-month' | 'quarter' | 'calendar-year' | 'custom';

export interface Period {
  preset: PeriodPreset;
  /** Apenas usado se preset === 'custom'. */
  customRange?: { from: Date; to: Date };
}

export interface Filters {
  period: Period;
  /** Lista de fornecedores seleccionados — vazio = todos. */
  suppliers: string[];
  /** Lista de categorias seleccionadas — vazio = todas. */
  categories: string[];
  /** Vista monetária activa (afecta KPIs e charts). */
  moneyView: MoneyView;
  /** Locale UI — pt-PT por defeito; placeholders en-GB / es-ES. */
  locale: 'pt-PT' | 'en-GB' | 'es-ES';
}

export const DEFAULT_FILTERS: Filters = {
  period: { preset: 'all' },
  suppliers: [],
  categories: [],
  moneyView: 'refund',
  locale: 'pt-PT',
};
